import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
} from "reactstrap";
import { isEmpty } from "lodash";

import SiteTitle from "./../../../helpers/SiteTitle/SiteTitle";
import Button from "../../../components/Button/Button";
import Icon from "../../../components/Icon/Icon";
import PageHeader from "./../../../components/PageHeader/PageHeader";
import InfoItem from "./../../../helpers/InfoItem/InfoItem";
import { Col, Row } from "./../../../components/Grid/Grid";
import { snappTripAdminContext } from "../../../context/AdminContext/SnappTripAdminContext/SnappTripAdminContext";

const SnappTripAdmin = () => {
  const loader = useSelector((state) => state.loader);

  const { info, setInfo, handleLogin, handleGetUser, handleCheckHealth } =
    useContext(snappTripAdminContext);

  return (
    <>
      <SiteTitle title="اسنپ تریپ" />

      <PageHeader title="اسنپ تریپ" description="" />

      <Card>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <Card className="text-center">
                <CardHeader>بررسی سلامت API</CardHeader>
                <CardBody>
                  <Button
                    size="lg"
                    loading={loader}
                    color="info"
                    className="btn-block"
                    onClick={handleCheckHealth}
                  >
                    بررسی
                  </Button>
                </CardBody>
              </Card>
            </Col>
            <Col sm="6" md="4">
              <Card className="text-center">
                <CardHeader>ورود به اسنپ تریپ</CardHeader>
                <CardBody>
                  <Button
                    size="lg"
                    loading={loader}
                    color="success"
                    className="btn-block"
                    onClick={handleLogin}
                  >
                    ورود
                  </Button>
                </CardBody>
              </Card>
            </Col>
            <Col sm="6" md="4">
              <Card className="text-center">
                <CardHeader>دریافت اطلاعات</CardHeader>
                <CardBody>
                  <Button
                    size="lg"
                    loading={loader}
                    color="info"
                    className="btn-block"
                    onClick={handleGetUser}
                  >
                    دریافت
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Modal
        isOpen={!isEmpty(info)}
        toggle={() => setInfo({})}
        className="modal-dialog-centered"
        size="xl"
      >
        <ModalBody>
          <span type="button" onClick={() => setInfo({})} className="close">
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">اطلاعات اسنپ تریپ</h5>
            <br />
            <Row>
              <Col sm="6">
                <InfoItem title="عنوان">{info?.title}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نام کاربری">{info?.username}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="پست الکترونیک">{info?.email}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="شماره موبایل">{info?.mobile_no}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نام">{info?.first_name}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نام خانوادگی">{info?.last_name}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نام کامل">{info?.full_name}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="آدرس">{info?.address}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نوع قرار داد">
                  {info?.contract_type === "credit" && "اعتباری"}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نوع فاکتور">
                  {info?.invoice_type === "corporate" && "حقوقی"}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="نوع کاربر">
                  {info?.user_type === "agency" && "آژانس"}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="اعتبار">{info?.credit} ریال</InfoItem>
              </Col>
            </Row>
            {info.token && (
              <Alert color="success" className="text-center mt-3">
                ورود با موفقیت انجام شد
              </Alert>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SnappTripAdmin;
